<template>
	<div class="add_control">
		<el-dialog class="control_dialog" title="新增管理员" :visible.sync="dialogFormVisible" :modal="false" width="40%">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="add_control_form">
				<el-form-item class="add_control_form_item" label="管理员账号:" prop="adminAccount">
					<el-input v-model="ruleForm.adminAccount"></el-input>
				</el-form-item>
				<el-form-item class="add_control_form_item" label="管理员密码:" prop="adminPassword" show-password>
					<el-input v-model="ruleForm.adminPassword"></el-input>
				</el-form-item>
			</el-form>
			<div class="add_control_button_area">
				<el-button class="add_control_button" type="primary" @click="addConfirm()">确认注册</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			var validateAdminAccount = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('管理员账号不能为空！'));
				} else if (value.length != 11) {
					callback(new Error('建议最好将账号设定为11位的手机号！'));
				} else {
					callback();
				}
			};
			var validateAdminPassword = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('管理员账号不能为空！'));
				} else if (value.length <= 8 && value.length >= 15) {
					callback(new Error('建议密码设定长度在8-15位区间！'));
				} else {
					callback();
				}
			};
			return {
				dialogFormVisible: true,
				ruleForm: {
					adminAccount: '',
					adminPassword: '',
				},
				rules: {
					adminAccount: [{
						required: true,
						validator: validateAdminAccount,
						trigger: 'blur',
					}, ],
					adminPassword: [{
						required: true,
						validator: validateAdminPassword,
						trigger: 'blur',
					}, ],
				},
			};
		},
		props: {},
		methods: {
			addConfirm() {
				if (this.ruleForm.adminAccount != '' && this.ruleForm.adminPassword != '') {
					this.$emit('addAdmingAccount', this.ruleForm)
				} else {
					this.$message({
						message: '输入数据有误！',
						type: 'error'
					});
				}
			},
		},
	}
</script>

<style>
	.control_dialog {}

	.add_control_form {
		width: 70%;
		margin-left: 15%;
	}

	.add_control_button_area {
		margin-left: 45%;
		margin-top: 35px;
	}
</style>
